import {
  type ScratchcardOrderQuery,
  ScratchcardState,
} from '#api/shared/@types/generated/backend/graphql-schema-types'

export default defineNuxtRouteMiddleware(async (to) => {
  const client = useNuxtApp().$apollo.defaultClient
  const { navigateToLocalized } = useRouterUtils()

  const MY_ORDERS = `/my-orders/scratchcard/${to.params.id}`

  try {
    const response = await client.query<ScratchcardOrderQuery>({
      fetchPolicy: 'network-only',
      query: ScratchcardOrderDocument,
      variables: { orderId: to.params.id },
    })

    const scratchcards = response.data.scratchcardOrder.scratchcards
    const firstScratchableScratchcard = scratchcards.find(
      ({ status }) => status === ScratchcardState.Scratched,
    )

    if (!firstScratchableScratchcard) {
      return navigateToLocalized({ path: MY_ORDERS, replace: true })
    }

    return navigateToLocalized({
      path: `${MY_ORDERS}/scratching/${firstScratchableScratchcard.serialNumber}`,
    })
  } catch {
    return navigateToLocalized({ path: MY_ORDERS, replace: true })
  }
})
